import React, { useState, useEffect } from 'react';
import { IoInformationCircle } from "react-icons/io5";
import { TbListDetails } from "react-icons/tb";
import Select from 'react-select';
import Button from 'react-bootstrap/Button';
import { FaPencilAlt } from "react-icons/fa";
import { Alert } from 'react-bootstrap'; // Import Alert component
import axios from '../../Authservices/axiosInstance';
import { useParams, useNavigate } from "react-router-dom";

const EditUserRole = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [showAlert, setShowAlert] = useState(false); // State for alert

  // Fetch department roles from API
  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await axios.get('https://backend.ems.uk.hiradentallab.com/api/departmentRoles/');
        const roleOptions = response.data.map(role => ({
          value: role._id,
          label: role.name 
        }));
        setRoles(roleOptions);
      } catch (error) {
        console.error('Error fetching department roles:', error);
      }
    };
    fetchRoles();
  }, []);

  // Handle role selection
  const handleChange = (selectedOption) => {
    setSelectedRole(selectedOption);
  };

  // Handle update role button click
  const handleAddRole = async () => {
    if (!selectedRole) {
      setShowAlert(true); // Show alert if no role selected
      return;
    }

    try {
      const response = await axios.put(`https://backend.ems.uk.hiradentallab.com/api/user/assign-role/${userId}`, {
        departmentRoleId: selectedRole.value
      });

      if (response.status === 200) {
        setShowAlert(true); // Show alert for success
        setTimeout(() => {
          navigate('/user-roles'); // Navigate after alert
        }, 2000); // Delay navigation for 2 seconds
      }
    } catch (error) {
      console.error('Error updating department role:', error);
      setShowAlert(true); // Show alert for failure
    }
  };

  return (
    <div>
      <div className="salary-container">
        <div>
          <h1 className="salary-title">
            <IoInformationCircle className="salary-icon" /> Role Information
          </h1>
          <hr />
          <h2 className="salary-subtitle">
            <TbListDetails className="salary-icon" /> Role Details
          </h2>
          <hr />

          {/* Display alert message */}
          {showAlert && (
            <Alert variant="success" onClose={() => setShowAlert(false)} dismissible>
              Department role updated successfully!
            </Alert>
          )}

          <div className='table-container'>
            <div className='filter-container'>
              <div className="col-md-5">
                <div className="form-group">
                  <label htmlFor="dpt_role" style={{ fontWeight: 'bold' }}>
                    User Role <span style={{ color: 'red' }}> *</span>
                  </label>
                  <Select
                    id="dpt_role"
                    options={roles}
                    onChange={handleChange}
                    value={selectedRole}
                    placeholder="--Select Role--"
                    className="select2-hidden-accessible"
                  />
                </div>
              </div>
            </div>
          </div>
          <br />
          <Button variant="primary" onClick={handleAddRole}>
            <FaPencilAlt /> Add Role
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EditUserRole;
